<template>
  <div class="tag">
    <div
      :style="style"
      class="product-tag"
      v-if="
          productTag &&
          productTag.status &&
          productTag.image &&
          productTag.image.url &&
          productTag.style
        ">

      <v-img-card
        :data_url="productTag.image&&productTag.image.url"
        card_type="auto"
      ></v-img-card>
      <div
        class="product-tag__text">
        <div :style="{color:`${productTag.image_config.text_color}`}" >{{tagText(productTag.image_config.text)}}</div>
      </div>
    </div>

    <div v-if=" productTag.style == 0" >
      <div
        :style="shapeStyle"
        class="product-tag-shape"
        :class="'shape_'+productTag.shape"></div>
    </div>

  </div>

</template>
<script>
import getSymbolFromCurrency from "currency-symbol-map";
import vImgCard from '@/js/components/common/imgCard.vue';

export default {
  props: ["productTag","productInfo"],
  methods: {
    tagText(text){
      if(!text) return;
      let places ;
      if ((this.$store.state.pricetype == 'JPY') || (window.checkoutcurrency == "JPY" )) {
        places = 0;
      }
      places = !isNaN(places = Math.abs(places)) ? places : 2;
      let variable = text.match(/\{[^\}]+\}/g)
      variable?.forEach((item, index) => {
        switch(item){
          // SAVE_PERCENT - 节省百分比，
          case '{SAVE_PERCENT}':
            text = text.replace(/\{SAVE_PERCENT\}/,this.productInfo?.percentage?this.productInfo.percentage:0)
            break;
          // SAVE_AMOUNT - 节省金额，
          case '{SAVE_AMOUNT}':
            text = text.replace(/\{SAVE_AMOUNT\}/,`${getSymbolFromCurrency(this.$store.state.pricetype)}${(this.$store.state.rates[this.$store.state.pricetype] * (this.productInfo?.agio?this.productInfo.agio:0)).toFixed(places)}`)
            break;
          // PRICE - 价格，
          case '{PRICE}':
            text = text.replace(/\{PRICE\}/,`${getSymbolFromCurrency(this.$store.state.pricetype)}${(this.$store.state.rates[this.$store.state.pricetype] * this.productInfo.price).toFixed(places)}`)
            break;
          // SKU - 产品 SKU，
          case '{SKU}':
            text = text.replace(/\{SKU\}/,this.productInfo?.sku)
            break;
          // STOCK - 库存，
          case '{STOCK}':
            if(this.productInfo?.manage_stock == 'no'){
              text = this.$t('venue.productList.on_sale')
            }else{
              text = text.replace(/\{STOCK\}/,this.productInfo?.stock)
            }
            break;
        }
      });
      return text
    },
    // 获取节点符合要求的父节点
    // getParentStyle(node,key,notV){
    //   let styleValue = node.parentNode[key]
    //   if(notV.indexOf(styleValue)>=0){
    //     return this.getParentStyle(node.parentNode,key,notV)
    //   }else{
    //     return node.parentNode
    //   }
    // }
  },
  // mounted(){
  //   this.getParentStyle(this.$el,'offsetHeight',[0]).style.overflow= 'hidden'
  // },
  computed: {
    style() {
      let { width } = this.productTag.image_config;
      let { position } = this.productTag
      return {
        width: width + "%",
        top: position.p_y,
        left: position.p_x + '!important',
      };
    },
    shapeStyle(){
      let { width } = this.productTag.image_config;
      let { shape, position } = this.productTag
      let allshape=[{pos:'16%'},{pos:'0%'},{pos:'32%'},{pos:'48%'},{pos:'66%'},{pos:'82%'},{pos:'100%'}]
      return {
        top: position.p_y,
        left: position.p_x,
        width: width + "%",
        height: 0,
        paddingBottom:width+"%",
        backgroundPosition: `-${width*0.2}px calc( ${allshape[shape-1].pos} - ${width*0.2}px)`,
      };
    }
  },
  components: {
    vImgCard,
  },
};
</script>
<style scoped lang='scss'>
.tag{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  .product-tag{
    position: absolute;
    height: unset;
    z-index: 4;
    &__text{
      position: absolute;
      z-index: 6;
      width: 100%;
      transform: translate(-50%,-50%);
      height: unset;
      top: 50%;
      left: 50%;
      text-align: center;
      align-content: flex-start;
    }
    &__img {
      // position: absolute !important;
      height: unset !important;
      top: 0 ;
      left: 0 ;
      z-index: 5 !important;
      pointer-events: none !important;
      opacity: 1 !important;
    }
  }
  .product-tag-shape{
    position: absolute;
    z-index: 2 !important;
    pointer-events: none !important;
    opacity: 1 !important;
    background-image: url("../../../../../resources/images/productTag.png");
    background-size: cover;
    background-repeat: no-repeat;
    display: inline-block;
    padding: 0;
    border: 0;
    background-color: transparent;
    vertical-align: middle;
  }

}

</style>
